<template>
    <backend-layout title="Campaigns" create="campaign">
        <div class="has-table md:rounded border-gray-100 dark:bg-gray-900/70 bg-white border dark:border-gray-800 mb-6" v-if="campaigns.data.length > 0">
            <header class="card-header">
                <p class="card-header-title">
                    <span class="icon"><i class="mdi mdi-account-multiple"></i></span>
                    Campaigns
                </p>
            </header>
            <div class="card-content">
                <table>
                    <thead>
                    <tr>
                        <th>Name</th>
                        <th>URl</th>
                        <th>Description</th>
                        <th>Expires</th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="campaign in campaigns.data">
                        <td data-label="Name">{{ campaign.name }}</td>
<!--                        <td data-label="Code">{{ campaign.code }}</td>-->
                        <td data-label="Url">{{ campaign.url }}</td>
                        <td data-label="Description">
                            {{ campaign.description }}
                        </td>
                        <td data-label="Created">
                            <small class="text-gray-500" :title="campaign.expires_at">{{ campaign.expires_at }}</small>
                        </td>
                        <td class="actions-cell">
                            <div class="buttons right nowrap">
                                <a :href="route('campaigns.referrers',{'code':campaign.code})"
                                   class="button blue" title="Manage Referrers"
                                   data-original-title="Manage Referrers">
                                    <span class="icon"><i class="mdi mdi-account-group"></i></span>
                                </a>
                                <a :href="route('campaigns.analytics',{'code':campaign.code})"
                                   class="button green" title="Analytics"
                                   type="button">
                                    <span class="icon"><i class="mdi mdi-chart-areaspline"></i></span>
                                </a>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>

                <pagination :links="campaigns.links" :active-page="campaigns.current_page"
                            :total-pages="campaigns.total"></pagination>

            </div>
        </div>
        <div v-else>
            No Campaigns Available
        </div>
    </backend-layout>
</template>

<script>
import BackendLayout from "@/Layouts/BackendLayout";
import NewCampaign from "@/Components/NewCampaign";
import Pagination from "@/Components/Pagination";

export default {
    name: "Campaigns",
    props: {
        campaigns: Object
    },
    components: {Pagination, NewCampaign, BackendLayout}
}
</script>

<style scoped>

</style>
